import "./App.css";
import "./output.css";

import HomePage from "./pages/HomePage.js";

import SmoothScroll from "smooth-scroll";
import CalculatorHomePage from "./pages/CalculatorHomePage.js";
import LoginLanding from "./pages/LoginLandingPage.jsx";
import UnderConstruction from "./pages/UnderConstruction.js";
import ResetPassword from "./pages/ResetPassword.jsx";
import Subscription from "./pages/Subscription.jsx";
import ACTRegistration from "./pages/ACTRegistration.jsx";
import NotFoundPage from "./pages/NotFoundPage.jsx";
import ACTFreeTrialRedirect from "./pages/ACTFreeTrialRedirect.jsx";
import EmailVerificationPage from "./pages/EmailVerificationPage.jsx";

import BasicCalculator from "./apps/fleet-planning/basicCalculator.js";
import FleetPlanningDashboard from "./apps/fleet-planning/fleetPlanningDashboard.js";
import Profile from "./apps/fleet-planning/profile.js";
import Inputs from './apps/fleet-planning/inputs.js';
import Analytics from './apps/fleet-planning/analytics.js';
import Settings from "./apps/fleet-planning/settings.js";
import { AuthProvider } from "./components/router/authContext.jsx";
import { ProtectedRoute } from "./components/router/auth/ProtectedRoute.jsx";
import { PublicRoute } from "./components/router/auth/PublicRoute.jsx";

import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { initGA, PageTracker, debugLog, GADebugger } from "./utils/analytics";
import { GoogleMapsProvider } from "./contexts/GoogleMapsContext";

export const scroll = new SmoothScroll('a[href*="#"]', {
  speed: 1000,
  speedAsDuration: true,
});

function App() {
  useEffect(() => {
    initGA();
    if (process.env.NODE_ENV === "development") {
      debugLog("GA4 Initialized in debug mode");
    }
  }, []);

  return (
    <AuthProvider>
      <GoogleMapsProvider>
        <Router>
          <PageTracker />
          <GADebugger />
          <Routes>
            {/* Public routes - accessible to everyone */}
            <Route element={<PublicRoute />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/calculator" element={<CalculatorHomePage />} />
              <Route path="/fleet-planning-basic" element={<BasicCalculator />} />
              <Route path="/basic" element={<BasicCalculator />} />
              <Route path="/login" element={<LoginLanding />} />
              <Route path="/login/:token" element={<ACTFreeTrialRedirect />} />
              <Route path="/construction" element={<UnderConstruction />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/subscription" element={<Subscription />} />
              <Route path="/act-registration" element={<ACTRegistration />} />
              <Route path="*" element={<NotFoundPage />} />
            </Route>

            {/* Verification route - standalone */}
            <Route path="/verify-email/:token" element={<EmailVerificationPage />} />

            {/* Protected routes - only for authenticated users */}
            <Route element={<ProtectedRoute />}>
              <Route path="/fleet-planning-pro" element={<FleetPlanningDashboard />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/inputs" element={<Inputs />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </GoogleMapsProvider>
    </AuthProvider>
  );
}

export default App;
